/*
 * Purpose: Canonical Autoblocks BrandMark geometry and tones (ported from autoblocks.ai SSOT)
 * Last modified: 2026-06-26 | Agent
 * Completeness: 96
 */

/** Marketing / product accent — matches autoblocks.ai `--mkt-accent`. */
export const BRAND_MARK_ACCENT = '#0d9488';

export const BRAND_MARK_VIEW_BOX = '0 0 40 40';

export const BRAND_MARK_BLOCKS = {
  lowerLeft: { x: 4, y: 22, w: 14, h: 14, rx: 3, opacity: 0.95 },
  lowerRight: { x: 22, y: 22, w: 14, h: 14, rx: 3, opacity: 0.55 },
  upperCenter: { x: 13, y: 8, w: 14, h: 14, rx: 3, opacity: 0.75 },
  ghostCorner: { x: 4, y: 4, w: 8, h: 8, rx: 2 },
} as const;

export const BRAND_MARK_GHOST = {
  accentDefault: { fill: '#111111', opacity: 0.12 },
  accentDarker: { fill: '#0a0a0a', opacity: 0.2 },
  inverseDefault: { fill: 'rgba(255,255,255,0.22)', opacity: 1 },
  inverseLighter: { fill: 'rgba(255,255,255,0.36)', opacity: 1 },
} as const;

export type BrandMarkTone = 'accent' | 'inverse';
export type BrandMarkGhostAccent = 'lighter' | 'darker';
